export default __webpack_public_path__ + "static/media/main-team3.c46c8325.jpg";